import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-aif-cell-renderer',
  templateUrl: './aif-cell-renderer.component.html',
  styleUrl: './aif-cell-renderer.component.scss'
})
export class AifCellRendererComponent {
  isLocked: boolean = false;
  isAIFStarted: boolean = false;
  public Data!: any;
  public displayValue!: any;

  async agInit(params: ICellRendererParams): Promise<void> {
    this.displayValue = params;
    if (this.displayValue.ModuleName) {
      try {
        this.isLocked=this.displayValue.isLocked;
        this.isAIFStarted=this.displayValue.isAIFStarted;

      } catch (err) {
        console.error('Error checking permissions:', err);
      }
    }
  }

  onActionClick(actionType: string, _id: string, data: any) {
    this.Data = data ? data : '';
    this.displayValue.clicked(
      actionType,
      _id,
      this.Data,
      this.displayValue.data.avatarPath
    );
  }
}
